import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import PageContainer from "@/components/pages/COA/PageContainer";
import Title2 from "@/components/pages/COA/Title2";
import Description from "@/components/pages/COA/Description";

const TrainingPartners = ({ styles, trainingPartners }) => (
  <PageContainer className={styles.trainingPartnersSection}>
    <Title2>{trainingPartners.title}</Title2>
    <Description>{trainingPartners.description}</Description>
    {trainingPartners.partners && (
      <Grid container spacing={2} className={styles.partnersGrid}>
        {trainingPartners.partners.map(({ partner }) => (
          <Grid
            sm={2}
            xs={3}
            key={partner.url_segment}
            className={styles.partnerGridItem}
          >
            <a
              href={`/marketplace/training/${partner.url_segment}/${partner.id}`}
              className={styles.partnerItem}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${partner.name} logo (opens in new tab)`}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className={styles.partnerLogo}
              />
            </a>
          </Grid>
        ))}
      </Grid>
    )}
    <Description>{trainingPartners.footerText}</Description>
  </PageContainer>
);

TrainingPartners.propTypes = {
  styles: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  trainingPartners: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    partners: PropTypes.arrayOf(
      PropTypes.shape({
        partner: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          url_segment: PropTypes.string,
          logo: PropTypes.string
        })
      })
    ),
    footerText: PropTypes.string.isRequired
  }).isRequired
};

export default TrainingPartners;
